import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Catch unhandled promise rejections (e.g., stray fetch failures) so they
// never bubble up and crash the Capacitor WebView. We just log them.
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event?.reason;
      // eslint-disable-next-line no-console
      console.warn('[carloo] unhandled rejection swallowed:', reason?.message || reason);
      event.preventDefault?.();
    } catch {}
  });
  window.addEventListener('error', (event) => {
    // Don't reload on resource-load errors (images / scripts blocked offline).
    // eslint-disable-next-line no-console
    console.warn('[carloo] window error:', event?.message || event);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
